import {useMemo} from "react";
import {ButtonTypesProps} from "../components/FooterForm";

export type SaveCancelButtonConfigOptions = {
  onSubmit: (...params: any[]) => any;
  onCancel: (...params: any[]) => any;
};

export const useSaveCancelButtonConfig = ({ onSubmit, onCancel }: SaveCancelButtonConfigOptions) => useMemo<ButtonTypesProps[]>(() => [
  {
    title: 'Cancelar',
    handleOnClick: onCancel,
    typeButton: 'submit',
  },
  {
    title: 'Guardar',
    handleOnClick: onSubmit,
    typeButton: 'submit',
  },
], [onCancel, onSubmit]);
